import {
  Col,
  ENotificationType,
  Row,
  TRtkErrorType,
  useGetValidationData,
  useShowToastNotification,
  useTranslation,
} from '@packages/utils';
import EditableInput from 'components/Base/EditableFields/EditableInput';
import { InplaceEditLabels } from 'components/Base/EditableFields/components/InplaceEditLabel';
import { useUpdatePeopleMobileMutation } from 'redux/apiSlice/people.slice';
import { EIconNames } from 'components/Base/Icon';
import { formatPhoneNumber } from 'helpers/utils';
import { TPeopleMobileProps } from './PeopleMobile.types';

const PeopleMobile = ({ userId, data }: TPeopleMobileProps) => {
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.people.details.details-tab.main-contact.mobile',
  });
  const { validationRules } = useGetValidationData();
  const { showToastNotification } = useShowToastNotification();
  const [editMobile, { isLoading, isError }] = useUpdatePeopleMobileMutation();

  const onEdit = async (value: string) => {
    try {
      await editMobile({
        userId,
        phone: value,
      }).unwrap();
      showToastNotification({
        message: t('SUCCESS_MESSAGE'),
        type: ENotificationType.SUCCESS,
      });
    } catch (e) {
      showToastNotification({
        message: (e as TRtkErrorType)?.data?.message,
        type: ENotificationType.ERROR,
      });
    }
  };

  return (
    <Row align="middle" wrap={false} className="w-100 mb-1">
      <Col>
        <InplaceEditLabels
          label={t('INPLACE_EDIT_LABEL')}
          icon={EIconNames.PHONE_OUTLINED}
        />
      </Col>
      <Col flex="auto">
        <EditableInput
          onEdit={onEdit}
          title={formatPhoneNumber(data.value ?? null)}
          isError={isError}
          isLoading={isLoading}
          fitContent={false}
          validateTrigger="onSubmit"
          rules={[validationRules.phoneNumber()]}
          readonly={data?.allowedOperations.readonly}
          canRemove={data?.allowedOperations.canRemove}
          emptyText={t('EMPTY_TEXT')}
          placeholder={t('PLACEHOLDER')}
          backIcon
          phoneInput
        />
      </Col>
    </Row>
  );
};

export default PeopleMobile;
